<template>
  <div>
    <v-container fluid class="content-wrapper">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Orders
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12" class="d-flex justify-end">
          <v-btn
            v-if="role === 'super-admin'"
            @click="download"
            outlined
            class="black--text font-weight-bold mb-2"
            rounded
            medium
          >
            <v-icon color="black" small class="mr-2">
              mdi-download
            </v-icon>
            Download
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" class="justify-center d-flex">
          <v-btn-toggle v-model="toggleOrder" rounded mandatory>
            <v-btn value="equipment" class="btn-selected">
              Equipment
            </v-btn>
            <v-btn value="services" class="btn-selected">
              Services
            </v-btn>
            <v-btn value="patents" class="btn-selected">
              Patents
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-row v-if="toggleOrder === 'services'">
              <v-col cols="12">
                <TableServicesOrderAdmin
                  v-if="role === 'super-admin'"
                  ref="table"
                  :url-api="'/api/v1/orders/admin'"
                  :search="search"
                  :search-attributes="[]"
                  :key="tableKey"
                  :headers="headersServicesAdmin"
                  @delete="deleteHandler"
                >
                </TableServicesOrderAdmin>
              </v-col>
            </v-row>
            <v-row v-if="toggleOrder === 'equipment'">
              <v-col cols="12">
                <TableEquipmentOrderAdmin
                  v-if="role === 'super-admin'"
                  ref="table"
                  :url-api="'/api/v1/orders-equipment/admin'"
                  :search="search"
                  :search-attributes="[]"
                  :key="tableKey"
                  :headers="headersEquipmentAdmin"
                  @delete="deleteHandler"
                >
                </TableEquipmentOrderAdmin>
              </v-col>
            </v-row>
            <v-row v-if="toggleOrder === 'patents'">
              <v-col cols="12">
                <TablePatentsOrderAdmin
                  v-if="role === 'super-admin'"
                  ref="table"
                  :url-api="'/api/v1/orders-patent/admin'"
                  :search="search"
                  :search-attributes="[]"
                  :key="tableKey"
                  :headers="headersPatentAdmin"
                  @delete="deleteHandler"
                ></TablePatentsOrderAdmin>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <Loader :loading="isDownloading" />
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';
import TableServicesOrderAdmin from '@/components/order/TableServicesOrderAdmin';
import TableEquipmentOrderAdmin from './TableEquipmentOrderAdmin.vue';
import TablePatentsOrderAdmin from './TablePatentsOrderAdmin.vue';
import Loader from '../shared/helpers/Loader.vue';

export default {
  name: 'Orders',
  mixins: [util],
  components: {
    TableServicesOrderAdmin,
    TableEquipmentOrderAdmin,
    TablePatentsOrderAdmin,
    Loader,
  },
  data: () => ({
    search: {},
    tableKey: 0,
    headersServicesAdmin: [
      { text: 'Service', value: 'resource', sortable: true },
      { text: 'Provider', value: 'provider', sortable: false },
      { text: 'Order By', value: 'orderBy', sortable: false },
      { text: 'Order Date', value: 'orderDate', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Rating', value: 'rating', sortable: false },
      { text: '', value: 'actions' },
    ],
    headersEquipmentAdmin: [
      { text: 'Equipment', value: 'equipment', sortable: true },
      { text: 'Provider', value: 'provider', sortable: false },
      { text: 'Order By', value: 'orderBy', sortable: false },
      { text: 'Order Date', value: 'orderDate', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Rating', value: 'rating', sortable: false },
      { text: '', value: 'actions' },
    ],
    headersPatentAdmin: [
      { text: 'Patent', value: 'patent', sortable: true },
      { text: 'Organisation', value: 'organisation', sortable: false },
      { text: 'Order By', value: 'orderBy', sortable: false },
      { text: 'Order Date', value: 'orderDate', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Rating', value: 'rating', sortable: false },
      { text: '', value: 'actions' },
    ],
    toggleOrder: 'equipment',
    isDownloading: false,
  }),
  watch: {
    toggleOrder() {
      this.forceTableRerender();
    },
    '$route.query.toggleOrder'(newValue) {
      if (newValue) {
        this.toggleOrder = newValue;
      }
    },
  },
  mounted() {
    if (this.$route.query.toggleOrder) {
      this.toggleOrder = this.$route.query.toggleOrder;
    }
  },
  methods: {
    triggerSearch() {
      this.$refs.table.triggerSearch();
      this.forceTableRerender();
    },
    searchTextChanged(obj) {
      console.log('[App] searchTextChanged');
      this.search[obj.value] = obj.search;
    },
    searchSelectChanged(obj) {
      console.log('[App] searchSelectChanged');
      this.search[obj.value] = obj.search;
    },
    clear() {
      EventBus.$emit('clear');
      this.$nextTick(() => {
        this.triggerSearch();
        this.forceTableRerender();
      });
    },
    deleteHandler() {
      this.forceTableRerender();
    },
    forceTableRerender() {
      this.tableKey += 1;
    },
    download() {
      this.isDownloading = true;
      this.axios
        .get('api/v1/orders-equipment/admin/orders-download', {
          responseType: 'blob',
        })
        .then(response => {
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'Orders.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="([^"]*)"/);
            if (fileNameMatch) {
              fileName = fileNameMatch[1];
            }
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);

          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(error => {
          console.error('Error downloading file:', error);
        })
        .finally(() => {
          this.isDownloading = false;
        });
    },
  },
  computed: {
    role() {
      return this.$store.getters.roles;
    },
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
